import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName } from '../../icons';
import { MobileService } from '../../mobile';

@Component({
  selector: 'yat-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  constructor(private readonly mobileService: MobileService) {}

  @Input()
  isMinified: boolean = false;

  @Input()
  iconName: IconName = 'chevron-right';

  @Input()
  showIcon: boolean = true;

  @Output()
  cardSelect = new EventEmitter<Event>();

  selectCard(event: Event): void {
    this.cardSelect.emit(event);
  }

  isMobile(): boolean {
    return this.mobileService.isMobileScreenSize();
  }
}
